import { useQuery } from 'react-query';
import { searchBettie, type SearchBettieResponse } from '../../../bettie/services/bettieService';

export function useBettieSearch(query: string, options?: { enabled?: boolean }) {
  return useQuery<SearchBettieResponse>(
    ['bettie-search', query],
    () => searchBettie({ bettie_nickname: query }),
    {
      enabled: options?.enabled ?? false,
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000
    }
  );
}

